import React from 'react';
import dialogLoader from '../../utilities/dialogLoader';

/**
 * Todo:
 * プロジェクト全体でEditedをCommon.jsxからではなくこのファイルからimportする
 *
 * src/pages/modals/Common.jsxでは_masterSlideLoaderなど
 * classがinstance化された状態でimportされている
 *
 * _masterSlideLoaderなど使用していないEditedなどにもinstanceが渡っており、テストが大変。
 * 本来はすべて置き換えるべきだが、もしかしたらこの偶然紛れ込んでいるインスタンスを使っている
 * ページがあるかもしれないため、該当ページを修正する際に順次入れ替えを検討する。
 *
 * 上記理由で、Commonとこのファイルで同じComponentが重複している
 */
export const Edited = props => (
  <div id='modal-dialog-confirm-selected' className='modal show'>
    <div className='dialog-sm dialog--modal'>
      <div className='dialog-sm__header'>
        <span className='dialog-sm__title'>更新完了</span>
      </div>
      <div className='dialog-sm__footer'>
        <button
          id='modal-close-confirm-selected'
          className='btn-fixedsize--sub'
          onClick={() => {
            dialogLoader.close();
            if (props.dialog) {
              props.dialog.callback.done();
            }
          }}
        >
          了解
        </button>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/modals/Edited.jsx